import React from 'react';
import  BppGatewayBasicInfoComponent from './bpp-gateway-basic-info.component';
import TabContainer from '../../../../../common/components/tab/containers/tab.containers';

function BppGatewayComponent ({ 
  selectedEdgeGateway,
  handleBacicInnerFormChange,
  back,
}: any) {
    const tabItems=[
        {
            id:1,
            title:'Edge Gateway Basic Info',
            component: <BppGatewayBasicInfoComponent 
            handleBacicInnerFormChange={handleBacicInnerFormChange}
            selectedEdgeGateway={selectedEdgeGateway}
        />,
        isVisible:true,
        },
        // {
        //     id:2,
        //     title:'KeyPair',
        //     component: <GlobalRegistriesKeypairInfoComponent 
        //     handleBacicInnerFormChange={handleBacicInnerFormChange}
        //     selectedDbnpRegistry={selectedDbnpRegistry}
        //    />,
        //    isVisible:true,
        // }
     
      
      ]
  return (
    <div className="flex flex-col items-center w-full px-5 overflow-auto h-screen">
       
     
    <TabContainer tabItems={tabItems} />
 
    <div className='flex w-full justify-end items-end'>
      <button
            onClick={back}
            type='button'
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
           >
            Back
           </button>
      </div>
     </div>
  );
}
export default BppGatewayComponent;
